import { render } from "./devices.vue?vue&type=template&id=22985539&ts=true"
import script from "./devices.vue?vue&type=script&lang=ts"
export * from "./devices.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__